import * as yup from 'yup';

const popularItemListSchema = yup.object({
  fr: yup.string(),
  en: yup.string(),
  es: yup.string(),
  color: yup.string(),
});

export const popularItemSchema = yup.object({
  id: yup.string().required(),
  fr: yup.string().required(),
  es: yup.string().required(),
  en: yup.string().required(),
  categoryId: yup.string().required(),
  pictureUrl: yup.string(),
  selected: yup.boolean(),
  popularItemList: popularItemListSchema,
});
export type PopularItem = yup.InferType<typeof popularItemSchema>;

export const categorySchema = yup.object({
  id: yup.string().uuid().required(),
  colorDark: yup.string().required(),
  colorMedium: yup.string().required(),
  colorLight: yup.string().required(),
  icon: yup.string().required(),
  name: yup
    .object({ fr: yup.string().required(), en: yup.string().required(), es: yup.string().required() })
    .required(),
  popularItems: yup.array(popularItemSchema),
});

export type Category = yup.InferType<typeof categorySchema>;

export const serviceCategorySchema = yup.object({
  id: yup.string().uuid().required(),
  name: yup.string().required(), // i18n key; see common.serviceCategories.{name} // categorie.model.prisma !
});

export type ServiceCategory = yup.InferType<typeof serviceCategorySchema>;
